import { IconButton, List, ListItem, ListItemText, SvgIcon } from "@material-ui/core";
import * as React from "react";
import { FilterInputType } from "../../../src/Enums/FilterTypes";
import {
  dateOperations,
  filterOperations,
  numberOperations,
  textOperations,
  selectOperations,
  referenceOperations,
} from "./Constant/Source";
export default function FilterSelect(props) {
  const targetRef = React.useRef<any>(null);
  const fixedRef = React.useRef<any>(null);
  const [position, setPosition] = React.useState({ top: 0, left: 0 });
  const [selectedValue, setSelectedValue] = React.useState(props.defaultValue);
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    // It updates the position when the page is loaded, and when the screen size or scroll changes.
    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition);
    };
  }, []);

  React.useEffect(() => {
    setSelectedValue(props.defaultValue);
  }, [props.defaultValue]);

  const updatePosition = () => {
    if (targetRef.current) {
      const targetRect = targetRef.current.getBoundingClientRect();
      setPosition({
        top: targetRect.top + 44,
        left: targetRect.left - 13,
      });
    }
  };
  const handleListItemClick = value => {
    handleClose(value);
    setSelectedValue(value);
    props.handleChange(value);
  };
  const handleOpen = e => {
    if (props.disabled !== true) {
      setOpen(true);
    }
  };
  const handleClose = e => {
    setOpen(false);
  };
  return (
    <>
      <IconButton ref={targetRef} onClick={handleOpen} disabled={props.disabled}>
        <SvgIcon style={{ width: "1.8em", paddingTop: 7, marginLeft: -20 }}>
          <path d={filterOperations.find(x => x.id == selectedValue)?.icon} />
        </SvgIcon>
      </IconButton>
      {open && (
        <List
          ref={fixedRef}
          onMouseLeave={handleClose}
          style={{
            position: "fixed",
            zIndex: 1000,
            borderRadius: 15,
            background: "#fff",
            border: "#ddd 1px",
            borderStyle: "solid",
            top: `${position.top}px`,
            left: `${position.left}px`,
          }}
        >
          {filterOperations
            .filter(
              x =>
                (props.Type == FilterInputType.Date && dateOperations.includes(x.id)) ||
                (props.Type == FilterInputType.Number && numberOperations.includes(x.id)) ||
                (props.Type == FilterInputType.Text && textOperations.includes(x.id)) ||
                (props.Type == FilterInputType.Select && selectOperations.includes(x.id)) ||
                (props.Type == FilterInputType.Reference && referenceOperations.includes(x.id))
            )
            .map(item => {
              return (
                <ListItem style={{ padding: 5 }} autoFocus button onClick={() => handleListItemClick(item.id)}>
                  <SvgIcon
                    style={{
                      fontSize: "1.25em",
                      width: 40,
                      height: 25,
                      color: "#0000008a",
                    }}
                  >
                    <path d={item.icon} />
                  </SvgIcon>
                  <ListItemText
                    style={{
                      marginLeft: 20,
                      marginTop: 10,
                    }}
                    primary={item.label}
                  />
                </ListItem>
              );
            })}
        </List>
      )}
    </>
  );
}
